import React, { createContext, useReducer } from 'react';
import Button from '@material-ui/core/Button';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import reducer from './reducer';
import Header from './Header';
import {
  Container,
  Content,
  Sidebar,
  Main,
  StepContent,
  StepperActionsBox,
  ItemSidebar,
} from './styles';

export const WizardContext = createContext();

function Wizard({
  listOfSteps = [],
  title = 'Título',
  onDone = () => {},
  onClose = () => {},
}) {
  const initialState = { listOfSteps: listOfSteps, actualStep: 1 };
  const [state, dispatch] = useReducer(reducer, initialState);

  const step = listOfSteps[state.actualStep - 1];

  return (
    <Container>
      <WizardContext.Provider value={{ state, dispatch }}>
        <Header onClose={onClose} title={title} />
        <Main>
          <Content>
            <StepContent>
              <h2>{step.title}</h2>
              <step.Content onNext={() => dispatch({ type: 'NEXT_STEP' })} />
            </StepContent>

            <StepperActionsBox>
              {state.actualStep > 1 ? (
                <Button
                  onClick={() => dispatch({ type: 'BACK_STEP' })}
                  color='primary'>
                  <FiChevronLeft style={{ fontSize: '40px' }} />
                </Button>
              ) : (
                <span></span>
              )}
              {state.listOfSteps.length === state.actualStep ? (
                <Button
                  disabled={!step.isComplete}
                  variant='contained'
                  onClick={onDone}
                  color='primary'>
                  Concluir
                </Button>
              ) : (
                <Button
                  size='small'
                  disabled={!step.isComplete}
                  onClick={() => dispatch({ type: 'NEXT_STEP' })}
                  color='primary'>
                  avançar
                  <FiChevronRight style={{ fontSize: '40px' }} />
                </Button>
              )}
            </StepperActionsBox>
          </Content>
          <Sidebar>
            {step.listOfItemsSideBar.map((itemSidebar) => (
              <ItemSidebar>
                <h3>{itemSidebar.title}</h3>
                <article>
                  <itemSidebar.Content />
                </article>
              </ItemSidebar>
            ))}
          </Sidebar>
        </Main>
      </WizardContext.Provider>
    </Container>
  );
}

export default Wizard;
